import { Switch } from '@/components/ui/switch';

interface ToggleMiniProps {
	label: string;
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
}

/** Compact inline switch + label, for dense areas (action card heads). */
export function ToggleMini({ label, checked, onCheckedChange }: ToggleMiniProps) {
	return (
		<label className="inline-flex cursor-pointer items-center gap-1.5">
			<Switch checked={checked} onCheckedChange={onCheckedChange} className="h-4 w-7" />
			<span className="text-[11px] font-medium text-foreground">{label}</span>
		</label>
	);
}
